<script>
    import { Timestamp, addDoc, collection, deleteDoc, doc, getDoc, onSnapshot, orderBy, query, serverTimestamp, setDoc, startAt, updateDoc, where } from "firebase/firestore";
    import OffersList from "../components/offers/OffersList.svelte";
    import { db } from "../firebase/firestore";
    import { business, user } from "../firebase/auth";
    import LoadingOverlay from "../components/LoadingOverlay.svelte";
    import AddOffer from "../components/offers/AddOffer.svelte";
    import Warning from "../components/ui/Warning.svelte";
    import { intToCredits } from "../utils/utils";

    const offersRef = collection(db, "offers");

    const firstOfTheMonth = new Date();
    firstOfTheMonth.setDate(1);
    firstOfTheMonth.setHours(0, 0, 0, 0);

    const q = query(offersRef, where("owner", "==", $user.uid), orderBy("show_from"), startAt(Timestamp.fromDate(firstOfTheMonth)));
    
    let dealSettings;
    const dealSettingsObserver = onSnapshot(doc(db, "settings", "offers"), (doc) => {
        dealSettings = doc.data();
    })

    let offers = [];
    let loading = false;

    let unsub = onSnapshot(q, ((snap) => {
        offers = [];
        snap.forEach((doc) => {
            let offer = doc.data();
            offer.id = doc.id;
            offers.push(offer);
        })
        offers = offers;
    }))

    function add(e) {
        const offer = e.detail;
        try {
            var expiry_date;
            if (offer.show_from === undefined) {
                expiry_date = new Date();
                offer.show_from = serverTimestamp();
            } else {
                expiry_date = offer.show_from;
                offer.show_from = Timestamp.fromDate(offer.show_from);
            }
            expiry_date.setDate(expiry_date.getDate() + e.detail.show_for_days);
            addDoc(collection(db, "offers"), {
                v: 1,
                subject: offer.subject,
                message: offer.message,
                show_from: offer.show_from,
                show_until: Timestamp.fromDate(expiry_date),
                owner: $user.uid,
                business: $business.id,
                created: serverTimestamp()
            })
            // $business.offers.credits -= 1;
        } catch (error) {
            console.log(error);
        }
    }

    function edit(e) {
        loading = true;
        let editRef = doc(db, "offers", e.detail.id);
        updateDoc(editRef, {
            ...e.detail,
        });
        loading = false;
    }

    function toggle(e) {
        loading = true;
        let editRef = doc(db, "offers", e.detail.id);
        updateDoc(editRef, {
            ...e.detail,
        });
        loading = false;
    }

    function remove(e) {
        try {
            console.log(e.detail.id);
            deleteDoc(doc(db, "offers", e.detail.id));
        } catch (error) {
            console.log(error);
            loading = false;
        }
    }
</script>

{#if $business && dealSettings }
    <h1>Angebote</h1>
    <p>Du kannst Nutzern, die deinem Account folgen sofort oder zu einem festgelegtem Zeitpunkt <b>Angebote schicken</b>. Das Angebot erscheint bei deinen Followern im <b>Angebots-Feed</b> und für Follower mit aktivierter Glocke zusätzlich als <b>Pushnachricht</b>.</p>
    <p>Du kannst <b>monatlich {dealSettings.offers_per_month} Angebote</b> posten. Wenn du ein geplantes Angebot löscht, bevor es live geht wird es nicht berechnet.</p>

    {#if $business.credits}
        <div class="list">
            <OffersList bind:credits={$business.credits} bind:offers={offers} bind:dealSettings on:remove={remove}  on:toggle={toggle} on:edit={edit} on:add={add}/>
        </div>
        <div class="action-bar">
            <AddOffer bind:credits={$business.credits} bind:dealSettings on:add={(e) => add(e)}/>
        </div>
    {:else}
        <Warning>
            Angebote sind für deinen Betrieb aktuell noch nicht freigeschaltet.
        </Warning>
    {/if}
{/if}
{#if loading}
    <LoadingOverlay/>
{/if}


<style>
    .list {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }

    .action-bar {
        position: sticky;
        bottom: 0;
        z-index: 5;
        display: flex;
        flex-direction: column;
        /* background-color: white; */
        /* background-color: rgba(255, 255, 255, 0.4); */
        background: linear-gradient(0deg, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0.8));
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
    }
</style>